/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponseModel, CommonResponseModel } from 'types/common'
import {
  GiftConditionCreateModel,
  GiftConditionDeleteModel,
  GiftConditionModel,
  GiftConditionUpdateModel,
} from 'types/gift-conditions'
import axiosInstance from './axios'

const conditionApis = {
  create: (payload: GiftConditionCreateModel) =>
    axiosInstance.post<any, ApiResponseModel<CommonResponseModel>>(
      'insertgiftcondition',
      payload
    ),
  getList: () =>
    axiosInstance.get<any, ApiResponseModel<Array<GiftConditionModel>>>(
      'getgiftcondition'
    ),
  getDetails: (id: string) =>
    axiosInstance.get<any, ApiResponseModel<Array<GiftConditionModel>>>(
      `giftconditiondetail`,
      {
        params: {
          id: id,
        },
      }
    ),
  update: (payload: GiftConditionUpdateModel) =>
    axiosInstance.post<any, ApiResponseModel<CommonResponseModel>>(
      'updategiftcondition',
      payload
    ),
  delete: (payload: GiftConditionDeleteModel) =>
    axiosInstance.post<any, ApiResponseModel<CommonResponseModel>>(
      'deletegiftcondition',
      payload
    ),
}

export default conditionApis
